function _log(name, type) {
  if (name && typeof name === 'string') {
    let printName = name;
    while (printName.length < 23) {
      printName = ' ' + printName;
    }
    let p1 = `%c#[${printName}]%c[%s]:%c, ${type}`;
    let p2 = ['color:#4c91c5', 'color:#CCCCCC', new Date().toLocaleTimeString(), 'color:black'];
    console.debug(p1, ...p2);
  }
}

function _check(options) {
  return !!options.name && options.__file
}

const Lifecycle = {
  install(Vue) {
    Vue.mixin({
      created() {
        if (_check(this.$options)) {
          _log(this.$options.name, 'created');
        }
      },
      unmounted() {
        if (_check(this.$options)) {
          _log(this.$options.name, 'unmounted');
        }
      },
    });
  },
}
export default Lifecycle;
